/* tslint:disable */

declare var Object: any;
export interface UploadInterface {
  "type": number;
  "name": string;
  "uploadDate": Date;
  "uploader": number;
  "hasLineError"?: boolean;
  "hasLineWarning"?: boolean;
  "status": number;
  "completedDate"?: Date;
  "error"?: string;
  "id"?: number;
  user?: any;
}

export class Upload implements UploadInterface {
  "type": number;
  "name": string;
  "uploadDate": Date;
  "uploader": number;
  "hasLineError": boolean;
  "hasLineWarning": boolean;
  "status": number;
  "completedDate": Date;
  "error": string;
  "id": number;
  user: any;
  constructor(data?: UploadInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Upload`.
   */
  public static getModelName() {
    return "Upload";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Upload for dynamic purposes.
  **/
  public static factory(data: UploadInterface): Upload{
    return new Upload(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Upload',
      plural: 'Uploads',
      path: 'Uploads',
      idName: 'id',
      properties: {
        "type": {
          name: 'type',
          type: 'number',
          default: 0
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "uploadDate": {
          name: 'uploadDate',
          type: 'Date'
        },
        "uploader": {
          name: 'uploader',
          type: 'number'
        },
        "hasLineError": {
          name: 'hasLineError',
          type: 'boolean',
          default: false
        },
        "hasLineWarning": {
          name: 'hasLineWarning',
          type: 'boolean',
          default: false
        },
        "status": {
          name: 'status',
          type: 'number',
          default: 0
        },
        "completedDate": {
          name: 'completedDate',
          type: 'Date'
        },
        "error": {
          name: 'error',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        user: {
          name: 'user',
          type: 'any',
          model: '',
          relationType: 'belongsTo',
                  keyFrom: 'uploader',
          keyTo: 'id'
        },
      }
    }
  }
}
